import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getReviewConfig} from '../../components/review/config/reviews'
import {useReevoo} from './use-reevoo'

//Integrations
import {useMarketingCloudTracking} from './use-marketing-cloud-tracking'
import {useBazaarvoice} from './use-bazaar-voice-pixel'

/**
 * useGetIntegrations - This hooks runs when the App component initializes and calls all the hooks that run third party integrations
 */

export const useGetIntegrations = (bazaarVoiceConfigPerCountry, feefoConfigurationPerCountry) => {
    const {locale} = useMultiSite()

    const countryCode = locale.id.split('-')[1]
    const languageCode = locale.id.split('-')[0]
    const {environment, provider, client_name, site_id} = getReviewConfig(
        locale.id,
        bazaarVoiceConfigPerCountry,
        feefoConfigurationPerCountry,
    )
    const reevooCode = feefoConfigurationPerCountry?.trkref

    useMarketingCloudTracking()
    useBazaarvoice(client_name, site_id, environment, provider, `${languageCode}_${countryCode}`)
    useReevoo(reevooCode, provider)
}
